import { FC } from "react";
import { Modal, Button, Badge } from "react-bootstrap";
import type { OrgUser } from "@services/permissions/commands/cmdListOrgUsers";

interface Props {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  user: OrgUser | null;
  isSaving: boolean;
}

const ReactivateUserModal: FC<Props> = ({ show, onClose, onConfirm, user, isSaving }) => (
  <Modal show={show} onHide={onClose} centered>
    <Modal.Header closeButton>
      <Modal.Title as="h5">Reactivate User</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className="mb-3">
        <strong>{user ? `${user.first_name} ${user.last_name}` : ""}</strong> will be able to
        sign in again.
      </p>
      {/* Deactivation leaves roles attached, so this restores whatever the row
        already shows rather than the roles the person held before they left.
        Saying so here is the only place an admin sees it before clicking. */}
      <p className="text-muted small mb-2">
        They return with the roles listed on their row:
      </p>
      <div className="d-flex flex-wrap gap-1">
        {user && user.roles.length > 0 ? (
          user.roles.map((r) => (
            <Badge key={r.id} bg="light" text="dark" className="border px-2">{r.name}</Badge>
          ))
        ) : (
          <span className="text-muted small fst-italic">No roles</span>
        )}
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="light" onClick={onClose}>Cancel</Button>
      <Button variant="primary" onClick={onConfirm} disabled={isSaving}>
        {isSaving ? (
          <><span className="spinner-border spinner-border-sm me-2" /> Reactivating...</>
        ) : (
          <><i className="bi bi-arrow-counterclockwise me-2" />Reactivate</>
        )}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ReactivateUserModal;
